import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@components/ui/dialog'

type FavoritesErrorDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  error: unknown
}

/** "Unable to load My Favorites" dialog, showing the load error's message when there is one. */
export function FavoritesErrorDialog({ open, onOpenChange, error }: FavoritesErrorDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Unable to load My Favorites</DialogTitle>
          <DialogDescription>
            {error instanceof Error
              ? error.message
              : 'Something went wrong while loading your favorited photos. Please try again.'}
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
